<template>
  <div>
    <component
      :is="getComponents"
      @fileValid="fileValid"
      :data.sync="formData"
      :config="baseData"
      :disable="disableValue(baseData)"
    >
    </component>
    <p v-if="baseData.rules.otherConfig.isTip == true">
      <span
        class="tipStyle"
        :style="{
          color: baseData.rules.otherConfig.tipColor || '#606266',
        }"
        >提示：{{ baseData.rules.otherConfig.tipValue }}</span
      >
    </p>
  </div>
</template>

<script>
import DateForm from "@/components/formList/DateForm.vue";
import FileForm from "@/components/formList/FileForm.vue";
import RichForm from "@/components/formList/RichForm.vue";
import SelectForm from "@/components/formList/SelectForm.vue";
import TextForm from "@/components/formList/TextForm.vue";
export default {
  components: {
    TextForm,
    SelectForm,
    DateForm,
    FileForm,
    RichForm,
  },
  name: "FormItem",
  props: ["baseData", "data", "otherConfig", "operateFlag"],
  computed: {
    disableValue() {
      return function (value) {
        let disableFlag = 0; // 0 不禁用、1禁用
        // 判断编辑状态下是否需要禁用
        if (this.operateFlag == 2) {
          let disableFieldArr =
            this.otherConfig?.moreConfig?.disableFieldArr || [];
          if (disableFieldArr.includes(value.enName)) {
            disableFlag = 1;
          }
        }
        return disableFlag === 0 ? false : true;
      };
    },
    getComponents() {
      if (this.baseData.rules.type == "text") {
        return "TextForm";
      } else if (this.baseData.rules.type == "select") {
        return "SelectForm";
      } else if (this.baseData.rules.type == "date") {
        return "DateForm";
      } else if (this.baseData.rules.type == "file") {
        return "FileForm";
      } else if (this.baseData.rules.type == "rich") {
        return "RichForm";
      } else {
        return null;
      }
    },
    formData: {
      get() {
        return this.data;
      },
      set(val) {
        this.$emit("update:data", val);
      },
    },
  },
  methods: {
    fileValid(key) {
      this.$emit("fileValid", key);
    },
  },
};
</script>
